import { render, staticRenderFns } from "./VueQueryDevtoolsPanel.vue?vue&type=template&id=08c9ea6c"
import script from "./VueQueryDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueQueryDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.7.4_webpack@5.103.0__ejs@3.1.1_beeed02dd832a1e8a219df4e9dcab5f9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports